import { toDate } from "@/lib/format";

export const DATE_PRESETS = [
  { key: "all", label: "All time" },
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "week", label: "This week" },
  { key: "last7", label: "Last 7 days" },
  { key: "month", label: "This month" },
  { key: "last30", label: "Last 30 days" },
  { key: "lastmonth", label: "Last month" },
  { key: "custom", label: "Custom range" },
];

const sod = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Returns [from, to) for a preset (to exclusive), or null for "all".
export function rangeFor(preset, from, to) {
  const t = sod(new Date());
  switch (preset) {
    case "today": return [t, addDays(t, 1)];
    case "yesterday": return [addDays(t, -1), t];
    case "week": { const dow = (t.getDay() + 6) % 7; return [addDays(t, -dow), addDays(t, 1)]; }
    case "last7": return [addDays(t, -6), addDays(t, 1)];
    case "month": return [new Date(t.getFullYear(), t.getMonth(), 1), addDays(t, 1)];
    case "last30": return [addDays(t, -29), addDays(t, 1)];
    case "lastmonth": return [new Date(t.getFullYear(), t.getMonth() - 1, 1), new Date(t.getFullYear(), t.getMonth(), 1)];
    case "custom": return [from ? sod(from) : new Date(0), to ? addDays(sod(to), 1) : addDays(t, 1)];
    default: return null;
  }
}

export const inRange = (value, range) => {
  if (!range) return true;
  const d = toDate(value);
  return !!d && d >= range[0] && d < range[1];
};
